"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "multipleAttendeeCameraStatusChanged", {
  enumerable: true,
  get: function get() {
    return _multipleAttendeeCameraStatusChanged["default"];
  }
});
var _multipleAttendeeCameraStatusChanged = _interopRequireDefault(require("./multipleAttendeeCameraStatusChanged"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }